import { Component, computed, inject, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsCollection, CmsTaxonomyGeneral } from '@fcom/core-api';

@Component({
  selector: 'cms-accordion',
  templateUrl: './cms-accordion.component.html',
  styleUrls: ['cms-accordion.component.scss'],
  standalone: false,
})
export class CmsAccordionComponent {
  private activatedRoute = inject(ActivatedRoute);

  content = input.required<CmsCollection>();

  withPictures = input(false);

  readonly routeFragment = this.activatedRoute.snapshot.fragment;

  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TAXONOMY: typeof CmsTaxonomyGeneral = CmsTaxonomyGeneral;

  readonly mappedContent = computed<CmsCollection>(() => {
    const content = this.content();
    return {
      ...content,
      items: content.items.map((item) => {
        return {
          ...item,
          subjectTaxonomyTags: (item.subjectTaxonomyTags || []).concat([CmsTaxonomyGeneral.NO_TITLE]),
        };
      }),
    };
  });

  readonly showTitle = computed(() => {
    const content = this.mappedContent();
    return !!content.teaserTitle && content.subjectTaxonomyTags.indexOf(CmsTaxonomyGeneral.NO_TITLE) === -1;
  });
}
